import { TimeFrameItemProps } from "apis";
import { lazy } from "react";

export const PageAdminTimeFrame = lazy(() => import("./List"));
export const PageAdminTimeFrameCreate = lazy(() => import("./Add"));
export const PageAdminTimeFrameUpdate = lazy(() => import("./Edit"));

export interface FormTimeFrameValuesProps extends TimeFrameItemProps { }